var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "up",
    d: "M7.86496 5.5H2.13504C1.71112 5.5 1.47954 5.00557 1.75093 4.67991L4.61589 1.24196C4.81579 1.00208 5.18421 1.00208 5.38411 1.24196L8.24907 4.67991C8.52046 5.00557 8.28888 5.5 7.86496 5.5Z",
    fill: "#A9A9A9",
    stroke: "#A9A9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "down",
    d: "M7.86496 8.5H2.13504C1.71112 8.5 1.47954 8.99443 1.75093 9.32009L4.61589 12.758C4.81579 12.9979 5.18421 12.9979 5.38411 12.758L8.24907 9.32009C8.52046 8.99443 8.28888 8.5 7.86496 8.5Z",
    fill: "#A9A9A9",
    stroke: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSort);
export default __webpack_public_path__ + "static/media/TableSort.aa47239aa938de3852c77d3c24de4a6c.svg";
export { ForwardRef as ReactComponent };